module.exports = __webpack_public_path__ + "static/nas.be229a01.png";